import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import BookingPage from './BookingPage';
import './BookingPage.less';

export const prefix = 'bm-p-booking';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: BookingPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
